import React from "react";
import img from "../../assets/about/last.png";
import patt from "../../assets/Home/model-patt.png";
import PinkBtn from "../../Components/PinkBtn";

function Last() {
  return (
    <div className="w-full flex justify-center items-center mt-[140px] xl:mt-[220px] px-5">
      <div className="xl:flex-row flex-col max-w-[1440px] flex justify-center items-center gap-16 xl:gap-24 w-full">
        <div className="relative isolate  flex justify-end items-center">
          <img
            src={patt}
            className="absolute -z-[1] -top-[10%] sm:-left-[8%] h-full -left-[4%]"
            alt=""
          />
          <img
            src={img}
            alt=""
            className="w-full max-w-[400px] xl:max-w-[522px]"
          />
        </div>
        <div className="flex justify-center text-justify items-start flex-col gap-4 xl:w-1/2">
          <h1 className="text-lightGreen-500 leading-9 sm:leading-[50px] font-bold text-[30px] sm:text-[48px]  ">
            A Lot Of Different Flowers
            <br />
            Make A Bouquet
          </h1>
          <p className="text-lightGreen-500 font-normal text-lg ">
            At Cognitia, we recognize we’re not all the same which is why we are
            committed to identifying differences and adapting our approach.
          </p>
          <p className="text-lightGreen-500 font-normal text-lg ">
            We strive to foster a culture that celebrates what makes each of us
            unique, whether that be race, ethnicity, gender, sexual orientation,
            religion, national origin, disability/abilities, or socioeconomic
            background.
          </p>
          <p className="text-lightGreen-500 font-normal text-lg ">
            We acknowledge the lived experiences and diverse perspectives of our
            staff and the children and families we serve.
          </p>
          <p className="text-lightGreen-500 font-normal text-lg ">
            Our mission is to foster a community founded on trust, respect,
            tolerance, and empathy.
          </p>
          <p className="text-lightGreen-500 font-normal text-lg ">
            Together, we’re stronger.
          </p>
          <div className="mt-6">
            <PinkBtn text={"Meet Our Team"} url={"Team"} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Last;
